// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"37d27b34fbf383c6b4e4","44983":"4ad8321a1bb0dab28d83","50169":"de09e3a07423cff187cf","58162":"baeaf9f711fc79b29e8b","63795":"642aad100f5014ec6e6d","66131":"d4d26425f1011ebb8c4e"}[chunkId] + ".min.js";
};